import { css } from "dx-styles"

import { tokens } from "../theme"

// No type annotations in this file: wyw hands `.ts` files back with
// TypeScript-only syntax intact, which the browser rejects in dev.

/** Anchors a popup to its trigger's width. Base UI publishes `--anchor-width`. */
export const popupPositioner = css({
  minWidth: "var(--anchor-width)",
  zIndex: 1,
})

/** The floating surface shared by the `Select` and `Combobox` popups. */
export const popupSurface = css({
  maxHeight: "min(20rem, var(--available-height))",
  overflowY: "auto",
  padding: tokens.space.xs,
  backgroundColor: tokens.color.surface,
  border: tokens.border.default,
  borderRadius: tokens.radius.md,
  boxShadow: tokens.shadow.base,
})

/**
 * One row in a popup list.
 *
 * Highlight is styled from `data-highlighted` rather than `:hover`, because Base
 * UI drives it from keyboard *and* pointer — using `:hover` would let the two
 * disagree.
 */
export const popupItem = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: tokens.space.sm,
  paddingBlock: tokens.space.xs,
  paddingInline: tokens.space.sm,
  borderRadius: tokens.radius.sm,
  cursor: "pointer",
  userSelect: "none",
  outline: "none",
  "&[data-highlighted]": {
    backgroundColor: tokens.color.hover,
  },
  "&[data-selected]": {
    fontWeight: tokens.fontWeight.semibold,
  },
  "&[data-disabled]": {
    cursor: "not-allowed",
    opacity: tokens.opacity.muted,
  },
})
